import { Group, Id, Identifiable, group as g } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "../linkers/types";
import { linkResources } from "../utils/linkResources";

function savePlanzoneResourceGroup(httpClient: HttpClient) {
  return (planzoneId: Id, group: Group) =>
    httpClient.sendHttpRequest<Identifiable<Group>>({
      endpoint: "/planzoneResourceGroups",
      method: HttpMethods.POST,
      data: {
        name: group.name,
        description: group.description,
        planzone: `planzone/${planzoneId}`,
        resources: group.resources.map(
          (resource) => `resources/${resource.uuid}`,
        ),
      },
    });
}

function saveProjectResourceGroup(httpClient: HttpClient) {
  return (projectId: Id, group: Group) =>
    httpClient
      .sendHttpRequest<LinkedResource<Identifiable<Group>>>({
        endpoint: "/projectResourceGroups",
        method: HttpMethods.POST,
        data: {
          name: group.name,
          description: group.description,
          project: `projects/${projectId}`,
          resources: group.resources.map(
            (resource) => `resources/${resource.uuid}`,
          ),
        },
      })
      .then((group) => linkResources(httpClient, group));
}

function saveResourceGroup(httpClient: HttpClient) {
  return (namespace: string, group: Identifiable<Group>) =>
    (group.resourceType === "project"
      ? saveProjectResourceGroup(httpClient)(namespace, group)
      : savePlanzoneResourceGroup(httpClient)(namespace, group)
    ).then((savedGroup) => ({
      ...g,
      ...group,
      ...savedGroup,
      resourceType: group.resourceType,
    }));
}

export { saveResourceGroup };
